const startOfDay = (value) => {
  const date = new Date(value);
  date.setHours(0, 0, 0, 0);
  return date;
};

const startOfWeek = (value) => {
  const date = startOfDay(value);
  date.setDate(date.getDate() - date.getDay());
  return date;
};

const startOfMonth = (value) => {
  const date = startOfDay(value);
  date.setDate(1);
  return date;
};

export const getDateSection = (value, now = new Date()) => {
  const parsed = value ? new Date(value) : null;
  if (!parsed || Number.isNaN(parsed.getTime())) {
    return { key: 'unknown', label: 'Unknown Date', order: Number.POSITIVE_INFINITY };
  }

  const day = startOfDay(parsed);
  const today = startOfDay(now);
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  const thisWeekStart = startOfWeek(today);
  const lastWeekStart = new Date(thisWeekStart);
  lastWeekStart.setDate(lastWeekStart.getDate() - 7);

  const thisMonthStart = startOfMonth(today);
  const lastMonthStart = new Date(thisMonthStart);
  lastMonthStart.setMonth(lastMonthStart.getMonth() - 1);

  if (day.getTime() === today.getTime()) {
    return { key: 'today', label: 'Today', order: 0 };
  }
  if (day.getTime() === yesterday.getTime()) {
    return { key: 'yesterday', label: 'Yesterday', order: 1 };
  }
  if (day >= thisWeekStart) {
    return { key: 'this_week', label: 'This Week', order: 2 };
  }
  if (day >= lastWeekStart) {
    return { key: 'last_week', label: 'Last Week', order: 3 };
  }
  if (day >= thisMonthStart) {
    return { key: 'current_month', label: 'This Month', order: 4 };
  }
  if (day >= lastMonthStart) {
    return { key: 'last_month', label: 'Last Month', order: 5 };
  }

  const monthKey = `${day.getFullYear()}-${String(day.getMonth() + 1).padStart(2, '0')}`;
  const monthsAgo =
    (today.getFullYear() - day.getFullYear()) * 12 + (today.getMonth() - day.getMonth());
  return {
    key: `month-${monthKey}`,
    label: `${String(day.getMonth() + 1).padStart(2, '0')}/${day.getFullYear()}`,
    order: 100 + monthsAgo,
  };
};

export const groupItemsByDateSection = (items, getDate) => {
  const groups = new Map();
  const sorted = [...(items || [])].sort((a, b) => {
    const aTime = new Date(getDate(a) || 0).getTime();
    const bTime = new Date(getDate(b) || 0).getTime();
    return bTime - aTime;
  });

  sorted.forEach((item) => {
    const section = getDateSection(getDate(item));
    if (!groups.has(section.key)) {
      groups.set(section.key, { ...section, items: [] });
    }
    groups.get(section.key).items.push(item);
  });

  return [...groups.values()].sort((a, b) => a.order - b.order);
};
